import { Col, Row } from 'antd';
import Image from 'next/image';
import Link from 'next/link';
import styled from 'styled-components';

import CuriousCuriLogoForButton from '../../assets/icons/CuriosCuriLogoForButton';
import AcceleratorPhoto from '../../assets/images/accelerator.png';
import AcceleratorBanner from '../../assets/images/acceleratorbanner.png';
import { useIsMobile } from '../../hooks/useIsMobile';
import { useMarketingMetrics } from '../../providers/PlausibleAnalyticsProvider';
import { Button } from '../_atoms/Button';
import { Cuributton } from '../_atoms/Cuributton';
import { IconWrapper } from '../_atoms/IconWrapper';
import MaxWidthContainer from '../_atoms/MaxWidthContainer';
import { CenteredContainer } from '../styled/CenteredContainer';

const AcceleratorHeader = ({ page }: { page: 'accelerator' | 'district' | 'school' }) => {
  const ismobile = useIsMobile();
  const { track } = useMarketingMetrics();
  return (
    <MaxWidthContainer
      backgroundImage={page === 'accelerator' ? AcceleratorBanner.src : undefined}
    >
      <HeadlineContainer $ismobile={ismobile}>
        <Col xs={24} md={12} lg={12} xl={12} xxl={12} style={{ padding: '40px 20px' }}>
          <Header>The Curipod Artificial Intelligence (AI) accelerator program</Header>
          <HeaderParagraph>
            Equip your teachers with the tools, strategies, and processes needed to handle
            the challenges and opportunities with artificial intelligence.
          </HeaderParagraph>
          <CenteredContainer style={{ flexWrap: 'wrap', gap: '20px' }}>
            {page === 'accelerator' && (
              <>
                <Link href="/accelerator-district">
                  <a onClick={() => track('accelerator-district')}>
                    <Button>Apply as district</Button>
                  </a>
                </Link>
                <Link href="/accelerator-school">
                  <a onClick={() => track('accelerator-school')}>
                    <Button>Apply as school</Button>
                  </a>
                </Link>
              </>
            )}
            {page === 'district' && (
              <a
                href="https://forms.gle/HstTa92XDnBXCfom6"
                onClick={() => track('accelerator-register-district')}
                target="__blank"
                rel="noopener noreferrer"
              >
                <Cuributton role="button">
                  <IconWrapper
                    height="60px"
                    width="60px"
                    style={{ position: 'absolute', top: -10, left: -10 }}
                  >
                    <CuriousCuriLogoForButton />
                  </IconWrapper>
                  <span style={{ whiteSpace: 'nowrap' }}>Register now</span>
                </Cuributton>
              </a>
            )}
            {page === 'school' && (
              <a
                href="https://share.hsforms.com/1rbEKFQW3Q4GcNOAr8Z8ANg4evga"
                onClick={() => track('accelerator-register-school')}
                target="__blank"
                rel="noopener noreferrer"
              >
                <Cuributton role="button">
                  <IconWrapper
                    height="60px"
                    width="60px"
                    style={{ position: 'absolute', top: -10, left: -10 }}
                  >
                    <CuriousCuriLogoForButton />
                  </IconWrapper>
                  <span style={{ whiteSpace: 'nowrap' }}>Register now</span>
                </Cuributton>
              </a>
            )}
          </CenteredContainer>
        </Col>
        <Col xs={24} md={12} lg={12} xl={12} xxl={12} style={{ padding: '40px 20px' }}>
          {page !== 'accelerator' && (
            <Image
              style={{ objectFit: 'contain' }}
              alt="Curicon banner"
              height={AcceleratorPhoto.height}
              width={AcceleratorPhoto.width}
              src={AcceleratorPhoto.src}
            />
          )}
        </Col>
      </HeadlineContainer>
    </MaxWidthContainer>
  );
};

const Header = styled.h1`
  color: white;
  font-size: 28px;
  text-align: left;
  margin-bottom: 0px;
  padding-bottom: 20px;

  @media (max-width: 1128px) {
  }
`;
const HeaderParagraph = styled.p`
  color: white;
  font-size: 18px;
  text-align: left;
  margin-bottom: 0px;
  padding-bottom: 20px;

  @media (max-width: 1128px) {
  }
`;

export default AcceleratorHeader;

const HeadlineContainer = styled(Row)<{ $ismobile: boolean }>`
  align-items: center;
  @media (max-width: 800px) {
    padding-bottom: 40px;
  }
`;
